import React, { Component } from "react"
// import { Link, navigate } from "gatsby"
import { Row, Col } from "react-bootstrap"
// import addaplay2 from "../../../img/newnbest/addaplay2.jpg"
// import addapantone from "../../../img/newnbest/addapantone.jpg"
// import addapantone2 from "../../../img/newnbest/addapantone2.jpg"
// import addaavenger from "../../../img/newnbest/addaavenger.jpg"
// import A4 from "../../../img/newnbest/A4.jpg"ฝ
import Axios from "axios"
import { REQUEST_URL, PATH_URL } from "../../../config"
import Carousel from "react-bootstrap/Carousel";

class PreviewNew extends Component {
  state = {
    data: [],
    Page: 5,
    Active: 1,
    PageCount: [],
    activeIndices: [],
    dataNew:[
      {
        hname:'รองเท้ารุ่น 2Density',
        description:`เปิดตัวรองเท้ารุ่น 2 Density 
        สุดเท่ ดีไซน์ทันสมัน สีสันสะดุดตา ด้วย
        นวัตกรรม ใหม่ของการผลิตรองเท้าจาก
        ADDA เป็นรองเท้าเพื่อสุขภาพ ช่วยในเรื่อง
        การเดินทำให้ลดอาการปวดเมื่อยที่เท้าและเข่า
        น้ำหนักเบา นุ่ม สบาย เมื่อสวมใส่ ไม่ว่าจะเดิน
        เล่น เดินเที่ยว เดินป่า คู่เดียวจบ ไม่ว่าชีวิตจะ
        เจออะไรหนัก ๆ แค่ใส่ ADDA 2Density`,
        img_path:[],
        nameimg:"01.jpg",
      },
      {
        hname:'รองเท้า EVA,PVC',
        description:`รองเท้ารุ่นนี้เป็นไอเท็มที่ไม่เคยตกยุค ด้วย
        ดีไซน์ที่เรียบหรูทั้งแบบหุ้มส้นและเปิดส้น ทำให้
        สามารถจับคู่กับเสื้อผ้าได้ง่าย ไม่ว่าจะเป็นชุด
        ทำงานหรือชุดลำลองก็ดูดี มีความคลาสสิกที่
        แฝงไว้ด้วยความสบาย ใส่ได้ทุกวันและในทุก
        สถานการณ์ สไตล์ที่เรียบง่ายแต่ทรงพลัง
        แบบนี้ ถือเป็นไอเท็มที่ต้องมีติดตู้ไว้!`,
        img_path:[],
        nameimg:"02.jpg",
      },
      {
        hname:'ADDA Sneaker',
        description:`รองเท้าทรงผ้าใบได้กลายเป็นหนึ่งในไอเท็มที่ขาดไม่
        ได้ในตู้รองเท้าของทุกคน ด้วยดีไซน์ที่ทันสมัยและ
        การใช้งานที่หลากหลาย รองเท้าเหล่านี้ไม่เพียงแต่
        มีรูระบายอากาศที่ช่วยให้เท้ารู้สึกสบายตลอดวัน
        แต่ยังมีคุณสมบัติที่โดดเด่นอย่างการกระชับเท้า
        ทำให้การเดินหรือวิ่งเป็นเรื่องง่ายและสบายมากยิ่ง
        ขึ้น
        นอกจากนี้ รองเท้าผ้าใบเหล่านี้ยังมีน้ำหนักเบาและ
        นุ่ม จึงเหมาะสำหรับทุกกิจกรรม ตั้งแต่การออก
        กำลังกาย ไปจนถึงการใช้ชีวิตประจำวัน และที่
        สำคัญคือมีหลายสีให้เลือก ไม่ว่าจะเป็นสีสดใสหรือ
        สีเรียบง่าย จึงตอบโจทย์ทั้งชายและหญิง ไม่ว่า
        คุณจะเป็นสายแฟชั่นหรือคนที่ชื่นชอบความสบาย
        ADDA Sneakerนี้คือทางเลือกที่ไม่ควรพลาด!`,
        img_path:[],
        nameimg:"03.jpg",
      },
      {
        hname:'รองเท้าหัวโต',
        description:`เป็นอีกหนึ่งทางเลือกที่ยอดเยี่ยมสำหรับผู้ชายที่
        ต้องการรองเท้าที่ทั้งสบายและเท่ ด้วยดีไซน์ที่ทัน
        สมัยและคุณสมบัติที่โดดเด่น ทำให้รองเท้าคู่นี้ตอบ
        โจทย์ความต้องการของผู้ที่มีไลฟ์สไตล์หลากหลาย

        รองเท้าหัวโต ADDA มีความนุ่มและเบา สวมใส่ได้
        ตลอดทั้งวันโดยไม่รู้สึกเมื่อยล้า มาพร้อมกับวัสดุที่
        ระบายอากาศได้ดี ช่วยให้เท้ารู้สึกสดชื่นไม่อับชื้น
        เหมาะสำหรับการเดินทางหรือกิจกรรมต่าง ๆ ทั้ง
        ในชีวิตประจำวันและการออกกำลังกาย อีกทั้งยังมี
        สไตล์ที่ดูทันสมัย สามารถแมชต์กับชุดได้หลาก
        หลาย ทำให้คุณสามารถก้าวออกไปด้วยความมั่นใจ
        ในทุก ๆ วัน!`,
        img_path:[],
        nameimg:"04.jpg",
      },
      {
        hname:'รองเท้าหัวโต ',
        description:`รองเท้าหัวโต ADDA สำหรับผู้หญิงมาพร้อมกับ
        ดีไซน์ที่น่ารักและทันสมัย ผสานกับความสบายที่
        ออกแบบมาให้เหมาะกับเท้าของคุณผู้หญิงโดย
        เฉพาะ ด้วยคุณสมบัติที่นุ่ม เบา และไม่หนักเท้า
        ทำให้รองเท้าคู่นี้เป็นตัวเลือกสำหรับการสวมใส่ใน
        ชีวิตประจำวัน

        นอกจากความสบายแล้ว รองเท้าหัวโต ADDA ยัง
        มีรูปลักษณ์ที่เรียบง่ายแต่เก๋ไก๋ สามารถแมชต์ได้
        กับทุกสไตล์การแต่งตัว ไม่ว่าจะเป็นวันทำงานหรือ
        วันหยุดพักผ่อน คุณสามารถสวมใส่รองเท้าคู่นี้ได้
        อย่างมั่นใจในทุกโอกาส เพิ่มความโดดเด่นในทุก
        ก้าวของคุณ ด้วยความนุ่มและน้ำหนักเบาที่ทำให้
        คุณรู้สึกสบายตลอดทั้งวัน!`,
        img_path:[],
        nameimg:"05.jpg",
      },
      {
        hname:'รองเท้า ADDA x ลิขสิทธิ์',
        description:`เป็นการผสมผสานระหว่างความสบายและความน่ารัก
        ที่มาพร้อมกับตัวการ์ตูนหรือแบรนด์ลิขสิทธิ์ยอดนิยม
        ไม่ว่าจะเป็นตัวละครจากการ์ตูนชื่อดังหรือสัญลักษณ์
        ที่แฟน ๆ ชื่นชอบ รองเท้าเหล่านี้จึงไม่เพียงแต่ใส่
        สบายด้วยดีไซน์และน้ำหนักเบา แต่ยังเพิ่มความโดด
        เด่นให้กับการแต่งตัวในทุกๆ วัน ทั้งความสบายและ
        ความสนุกสนานในทุกก้าว ยังเหมาะกับทุกเพศทุกวัย
        ทำให้คุณได้ทั้งแฟชั่นและความสบายในคู่เดียว!`,
        img_path:[],
        nameimg:"06.jpg",
      },
      {
        hname:'รองเท้าแตะ ADDA',
        description:`เป็นตัวเลือกยอดนิยมสำหรับผู้ที่มองหาความสบายและความ
        ทนทานในคู่เดียว ด้วยการออกแบบที่เรียบง่าย แต่ตอบโจทย์
        การใช้งานในทุกวัน รองเท้าแตะ ADDA ผลิตจากวัสดุ
        คุณภาพดี ที่มีความยืดหยุ่นสูงและนุ่มสบาย รองรับน้ำหนัก
        เท้าได้อย่างดีเยี่ยม

        อีกทั้งยังมีดีไซน์ที่เหมาะสำหรับทุกโอกาส ไม่ว่าจะเป็นการเดิน
        เล่น การทำกิจกรรมกลางแจ้ง หรือการใส่ไปทะเล รองเท้าแตะ
        ADDA มีหลากหลายสีและดีไซน์ให้เลือก เหมาะกับทุกเพศทุก
        วัย ไม่ว่าคุณจะชื่นชอบความเรียบง่าย หรือสไตล์ที่โดดเด่น
        รองเท้าแตะ ADDA ก็เป็นตัวเลือกที่ลงตัวที่สุด!`,
        img_path:[],
        nameimg:"07.jpg",
      },{
        hname:'รองเท้ารัดส้น ADDA',
        description:`เป็นรองเท้าที่ออกแบบมาเพื่อตอบโจทย์ผู้ที่ต้องการความ
        คล่องตัวและสบายในทุกการเคลื่อนไหว ด้วยดีไซน์ที่กระชับ
        และการรัดส้นที่มั่นคง ทำให้รองเท้ารุ่นนี้เหมาะสำหรับการใช้
        งานหลากหลาย ไม่ว่าจะเป็นการเดินทางไกล การทำกิจกรรม
        กลางแจ้ง หรือการใส่ในชีวิตประจำวัน

        รองเท้ารัดส้น ADDA ผลิตจากวัสดุคุณภาพดีที่ทั้งทนทาน
        และนุ่มสบาย ช่วยรองรับแรงกระแทกและให้ความรู้สึกเบา
        สบายในทุกย่างก้าว อีกทั้งยังมีดีไซน์ที่สวยงามทันสมัย มีให้
        เลือกหลายสีและขนาด จึงเหมาะกับทุกเพศทุกวัย ไม่ว่าจะ
        เป็นการใส่ไปทำงาน หรือใช้ในวันหยุดพักผ่อน รองเท้า ADDA
        รัดส้นคือตัวเลือกที่ตอบโจทย์ทั้งในเรื่องของฟังก์ชันและ
        สไตล์!`,
        img_path:["08-1.jpg", "08-2.jpg",
        ],
        nameimg:"08.jpg",
      },
      {
        hname:'ADDA ตัวติดรองเท้า',
        description:`ตัวติดรองเท้าสุดน่ารักเป็นไอเท็มที่ช่วยเพิ่มความสดใสให้กับ
        รองเท้าของคุณ ไม่ว่าจะเป็นลายการ์ตูน ตัวอักษร หรือ
        สัญลักษณ์สุดเก๋ ก็สามารถเปลี่ยนลุคของรองเท้าให้โดดเด่น
        และไม่ซ้ำใครได้ทันที ตัวติดรองเท้าเหล่านี้ยังช่วยบ่งบอก
        ความเป็นตัวตนของคุณในทุกก้าว!`,
        img_path:[ "09-1.png","09-2.png","09-3.png" ],
        nameimg:"09.png",
      }

    ]
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.Active !== this.state.Active) {
      let offset = (this.state.Active - 1) * this.state.Page
      let perpage = this.state.Active * this.state.Page
      const P = this.state.dataA.slice(offset, perpage)
      this.setState({
        data: P,
      })
    }
  }

  componentDidMount = () => {
    Axios.post(REQUEST_URL + "/previewnewpage/", {}).then(response => {
      if (response.data.status) {
        let offset = (this.state.Active - 1) * this.state.Page
        let perpage = this.state.Active * this.state.Page
        const PageCount = Math.ceil(response.data.data.length / this.state.Page)
        for (var x = 1; x < PageCount + 1; x++) {
          this.state.PageCount.push(x)
        }

        this.setState({
          // dataA: response.data.data,
          // data: test,
          dataA: this.state.dataNew,
          data: this.state.dataNew,
          Active: 1,
          activeIndices: this.state.dataNew.map(() => 0),
        })
      }
    })
  }

  Previous = () => () => {
    if (this.state.Active !== 1) {
      this.setState({
        Active: this.state.Active - 1,
      })
    }
  }

  Next = () => () => {
    if (this.state.Active < this.state.PageCount.length) {
      this.setState({
        Active: this.state.Active + 1,
      })
    }
  }

  Pagination = page => () => {
    this.setState({
      Active: page,
    })
  }


  handleSelect = (itemIndex, selectedIndex) => {
    this.setState((prevState) => {
      const newIndices = [...prevState.activeIndices];
      newIndices[itemIndex] = selectedIndex;
      return { activeIndices: newIndices };
    });
  };

  render() {
    return (
      <div
        className=""
        style={{
          width: "100%",
          marginTop: "2%",
          marginBottom: "2%",
        }}
      >
        <Row>
          <Col md="12" xs="12">
            {/* <label className="previewhead">
              ด้วยกระแส SANDALS รองเท้าแตะ เกิดความนิยมอยู่ตลอด ทำให้ช่วงนี้มองไปทางไหนก็มักจะเห็นวัยรุ่นทั้งหญิงและชาย
              นำรองเท้าแตะแมทช์กับเสื้อผ้าที่หลากหลาย ทำให้รองเท้าแตะเป็นหนึ่งเรื่องราวในด้านแฟชั่น
              และที่สำคัญเป็นรองเท้าเพื่อสุขภาพ อีกทั้ง มีการดีไซน์ที่ทันสมัย ตอบโจทย์คนรุ่นใหม่แน่นอ
              เราจะมาแนะนำให้เพื่อนๆ ได้รู้จักรองเท้าแตะแบรนด์ไทย COLLECTION ใหม่จาก ADDA
              ซึ่งวันนี้เราได้รวบรวมมาให้รู้จักทั้งหมด 5 รุ่น จะมีรุ่นไหนบ้างนั้น ลองมาดูกันเลย
            </label> */}

            <label className="previewhead">
            รองเท้าไม่ใช่แค่สิ่งที่ใช้เพื่อปกป้องเท้า แต่กลายเป็นส่วนสำคัญของแฟชั่นและไลฟ์สไตล์ที่สะท้อนความเป็นตัวตน
            ADDA รองเท้าดีไซน์เท่ ทันสมัย จึงเป็นตัวเลือกที่ตอบโจทย์สำหรับคนรุ่นใหม่ที่ต้องการทั้งความสบายและความโดด
            เด่นไม่ซ้ำใคร ไม่ว่าจะเป็นรองเท้าผ้าใบ รองเท้าหนัง รองเท้าแตะและแบบอื่นๆ การผสมผสานระหว่างดีไซน์เรียบหรู
            และรายละเอียดที่เข้ากับเทรนด์แฟชั่นล่าสุด ทำให้รองเท้าเหล่านี้ไม่เพียงแต่ใส่สบาย แต่ยังช่วยเสริมภาพลักษณ์และ
            สไตล์ให้คุณนำเทรนด์อยู่เสมอ
            ADDA จึงขอแนะนำ Collection ติดเทรนอยู่ในกระแสตลอดเวลามาแนะนำให้เพือนๆได้รู้จักกันค่ะ
            </label>
          </Col>
        </Row>
        {this.state.data.map((item, index) => {
          return (
            <div key={index}>
              {index % 2 === 0 ? (
                <Row style={{ marginTop: "2%" }}>
                  <Col md="7" xs="12">
                    <div
                      style={{ cursor: "pointer" }}
                    >
                      {item.img_path.length === 0 ?
                        <img
                          src={PATH_URL + "previewnew/" + item.nameimg}
                          width="100%"
                        /> : (
                          <Carousel activeIndex={this.state.activeIndices[index]} onSelect={(e) => this.handleSelect(index, e)}>
                          {item.img_path.map((items, idx) => {
                            return (
                                    <Carousel.Item key={idx}>
                                      <img
                                        className="d-block w-100"
                                        src={PATH_URL + "previewnew/" + items}
                                        alt="First"
                                      />
                                    </Carousel.Item>
                                    )
                          })}
                        </Carousel>
                      )
                    } 
                    </div>
                  </Col>
                  <Col md="1"></Col>
                  <Col
                    md="4"
                    xs="12"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <label className="previewfont">
                      <p
                        style={{
                          fontSize: "32px",
                          fontWeight: "bolder",
                          textDecoration: "underline",
                        }}
                      >
                        {item.hname}
                      </p>
                      {item.description}
                    </label>
                  </Col>
                </Row>
              ) : (
                <Row style={{ marginTop: "2%" }}>
                  <Col
                    md="4"
                    xs="12"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <label className="previewfont">
                      <p
                        style={{
                          fontSize: "32px",
                          fontWeight: "bolder",
                          textDecoration: "underline",
                        }}
                      >
                        {item.hname}
                      </p>
                      {item.description}
                    </label>
                  </Col>
                  <Col md="1"></Col>
                  <Col md="7" xs="12" style={{ cursor: "pointer" }}>
                    <div>
                     {item.img_path.length === 0 ?
                        <img
                          src={PATH_URL + "previewnew/" + item.nameimg}
                          width="100%"
                        /> : (
                          <Carousel activeIndex={this.state.activeIndices[index]} onSelect={(e) => this.handleSelect(index, e)}>
                          {item.img_path.map((items, idx) => {
                            return (
                                    <Carousel.Item key={idx}>
                                      <img
                                        className="d-block w-100"
                                        src={PATH_URL + "previewnew/" + items}
                                        alt="First"
                                      />
                                    </Carousel.Item>
                                    )
                          })}
                        </Carousel>
                      )
                    } 
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          )
        })}

        <Row style={{ marginTop: "2%" }}>
          <Col md="7" xs="12">
            <label className="previewfont">
              นี่ก็คือ รองเท้าแตะสวยๆ ซึ่งแต่ละคู่คุณภาพยอดเยี่ยม ใส่เดินเท่ๆ
              หวังว่าจะเป็นที่ชื่นชอบของเพื่อนๆ ทุกคน หากเพื่อนๆ
              สนใจคู่ไหนเป็นพิเศษก็รีบๆ จัดหามาให้กับตัวเองกันได้เลย
            </label>
            <label className="previewfont">
              ช้อปได้ที่ 
              <span
                style={{
                  color: "red",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() =>
                  window.open(
                    "https://www.lazada.co.th/shop/adda?path=index.htm&lang=th&pageTypeId=1"
                  )
                }
              >
                LAZADA
              </span>
               หรือ 
              <span
                style={{
                  color: "blue",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() =>
                  window.open("https://shopee.co.th/adda_online_shop")
                }
              >
                SHOPEE
              </span>
            </label>
          </Col>
        </Row>
        <Row style={{ marginTop: "5%" }}>
          {this.state.PageCount.length > 1 ? (
            <Col md="12" xs="12" sm="12">
              <nav
                aria-label="..."
                style={{ display: "flex", justifyContent: "center" }}
              >
                <ul className="pagination">
                  <li className="page-item" onClick={this.Previous()}>
                    <a
                      className="page-link"
                      style={{
                        cursor: "pointer",
                        color: "black",
                        fontSize: "20px",
                      }}
                    >
                      Previous
                    </a>
                  </li>

                  {this.state.PageCount.map(item => {
                    return (
                      <li className="page-item" onClick={this.Pagination(item)}>
                        <a
                          className={
                            this.state.Active === item
                              ? "page-link activepage"
                              : "page-link"
                          }
                          style={{
                            cursor: "pointer",
                            color: "black",
                            fontSize: "18px",
                          }}
                        >
                          {item}
                        </a>
                      </li>
                    )
                  })}

                  <li className="page-item" onClick={this.Next()}>
                    <a
                      className="page-link"
                      style={{
                        cursor: "pointer",
                        color: "black",
                        fontSize: "20px",
                      }}
                    >
                      Next
                    </a>
                  </li>
                </ul>
              </nav>
            </Col>
          ) : (
            ""
          )}
        </Row>
      </div>
    )
  }
}

export default PreviewNew
